import type { InquiryStatus } from '@vendorops/shared';
import { INQUIRY_STATUS_LABELS } from '@vendorops/shared';

/**
 * The pipeline reads left to right in weight: the further along an inquiry is,
 * the more the chip commits. Terminal off-ramps are deliberately quiet — a
 * declined florist should not shout louder than a booked one.
 */
const STATUS_STYLES: Record<InquiryStatus, string> = {
  draft: 'bg-[var(--color-surface-container-high)] text-muted-foreground',
  sent: 'bg-[var(--color-secondary-container)] text-foreground',
  replied: 'bg-[var(--color-primary-container)] text-foreground',
  quote_received: 'bg-[var(--color-tertiary-container)] text-foreground',
  contract_signed: 'bg-primary/80 text-primary-foreground',
  booked: 'bg-primary text-primary-foreground',
  declined: 'bg-[var(--color-surface-container-high)] text-muted-foreground line-through decoration-1',
  passed: 'bg-[var(--color-surface-container-high)] text-muted-foreground line-through decoration-1',
  no_response: 'bg-destructive/10 text-destructive',
};

export default function StatusChip({
  status,
  source,
}: {
  status: InquiryStatus;
  /** A dot marks a status a human set — PRD §6.2 wants every automated action
   *  attributable, which means the manual ones must be distinguishable. */
  source?: 'system' | 'user';
}) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[status]}`}
      title={source === 'user' ? 'Set by you' : 'Detected automatically'}
    >
      {source === 'user' && <span className="size-1 rounded-full bg-current opacity-60" />}
      {INQUIRY_STATUS_LABELS[status]}
    </span>
  );
}
